import { Component, Input, Optional, Self } from '@angular/core';
import {
  ControlValueAccessor,
  ReactiveFormsModule,
  FormsModule,
  NgControl,
} from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-custom-password-input',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule],
  templateUrl: './custom-password-input.component.html',
  styleUrl: './custom-password-input.component.css',
})
export class CustomPasswordInputComponent implements ControlValueAccessor {
  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() id: string = '';

  value: string = '';
  disabled: boolean = false;
  showPassword: boolean = false;

  constructor(@Optional() @Self() public ngControl: NgControl) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  get control() {
    return this.ngControl?.control;
  }

  get isInvalid() {
    return this.control?.invalid && (this.control?.touched || this.control?.dirty);
  }

  get errorMessage() {
    if (!this.control?.errors) return '';
    if (this.control.errors['required']) return `${this.label || 'Field'} is required`;
    return 'Invalid field';
  }

  onChange: (value: string) => void = () => { };
  onTouched: () => void = () => { };

  onInput(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.value = value;
    this.onChange(value);
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  writeValue(value: string): void {
    this.value = value || '';
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
